<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{ ...tooltip, ...dialog }" color="orange"
            ><v-icon>toc</v-icon>
          </v-btn>
        </template>
        <span>Change status</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <h2>Update Status</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-select
            v-model="newStatus"
            :items="statuses"
            menu-props="auto"
            label="Select"
            hide-details
            prepend-icon="map"
            single-line
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirmStatusChange"
            class="success mx-1 mt-3"
            :loading="loadingConfirm"
            ><v-icon>done</v-icon><span> Confirm change</span></v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String,
    },
  },
  data() {
    return {
      newStatus: "",
      loadingConfirm: false,
      loadingCancel: false,
      dialog: false,
      statuses: [
        "NEW",
        "CONFIRMED",
        "DISPATCHED",
        "CANCELLED",
        "PENDING"
      ]
    };
  },
  methods: {
    confirmStatusChange() {
        let updateBody = {
          cartId: this.cartId,
          status: this.newStatus,
        };
        cartApi.postUpdatePaymentInformation(updateBody).then(() => {
          this.loadingConfirm = false;
          this.dialog = false;
          this.$emit("statusChanged");
        });
    },
  },
};
</script>
